import { gql } from "@apollo/client";

export const CREATE_USER = gql`
  mutation CreateAccountingUser(
    $id: String!
    $role: AccountingUserRoleMutation!
  ) {
    createAccountingUser(_id: $id, role: $role) {
      status
      message
    }
  }
`;

export const GET_USER_WITH_PAGINATION = gql`
  query GetAccountingUsersWithPagination(
    $page: Int
    $limit: Int
    $keyword: String
    $role: AccountingUserRoleQuery
  ) {
    getAccountingUsersWithPagination(
      page: $page
      limit: $limit
      keyword: $keyword
      role: $role
    ) {
      data {
        _id
        userName
        email
        firstName
        lastName
        userProfile
        role
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const GET_USER_LOGIN = gql`
  query GetUserLogin($client: AllowUserPlatform) {
    getUserLogin(client: $client) {
      _id
      user_id
      imageSrc
      email
      isDisabled
      firstName
      lastName
      latinName
      gender
      phoneNumber
      role
      employeeType
      isChangedDefaultPassword
    }
  }
`;

export const UPDATE_USER_ROLE = gql`
  mutation UpdateAccountingUserRole(
    $id: ID!
    $role: AccountingUserRoleMutation!
  ) {
    updateAccountingUserRole(_id: $id, role: $role) {
      status
      message
    }
  }
`;

export const DELETE_USER = gql`
  mutation DeleteAccountingUser($id: ID!) {
    deleteAccountingUser(_id: $id) {
      status
      message
    }
  }
`;

export const GET_EMPLOYEE = gql`
  query GetEmployees($keyword: String!) {
    getEmployees(keyword: $keyword) {
      _id
      userName
      email
      firstName
      lastName
      userProfile
      role
    }
  }
`;

export const GET_EMPLOYEE_BY_ID = gql`
  query GetEmployeeByID($id: String!) {
    getEmployeeByID(_id: $id) {
      _id
      userName
      email
      firstName
      lastName
      userProfile
      role
    }
  }
`;

export const FORGOT_PASSWORD = gql`
  mutation ForgotPassword($id: ID!) {
    forgotPassword(_id: $id) {
      status
      message
    }
  }
`;

export const USER_LOGIN = gql`
  mutation UserLogin(
    $email: String!
    $password: String!
    $client: AllowUserPlatform
  ) {
    userLogin(email: $email, password: $password, client: $client) {
      token
      role
      message
      status
      isNeedToChangePassword
    }
  }
`;

export const CHANGE_PASSWORD_MAINUSER_AFTER_RESET_PASSWORD = gql`
  mutation ChangePasswordMainUserAfterResetPassword($newPassword: String) {
    changePasswordMainUserAfterResetPassword(newPassword: $newPassword) {
      token
      message
      role
      status
    }
  }
`;
